import { observable as t, action as r, useStrict as n } from "mobx";
export { useStrict } from "mobx";
var o = 3;

function e() {
  return global.__poaSatchelGlobalContext;
}

function a(t, r) {
  var n = e().subscriptions;
  n[t] || (n[t] = []), n[t].push(r);
}

function i(t) {
  if (e().inMutator) throw new Error("Mutators cannot dispatch further actions.");
  return (e().dispatchWithMiddleware || u)(t);
}

function u(t) {
  var r = h(t),
      n = e().subscriptions[r];

  if (n) {
    var o = [];
    if (n.forEach(function (r) {
      var n = r(t);
      n && o.push(n);
    }), o.length) return 1 === o.length ? o[0] : Promise.all(o);
  }
}

function c(t, r) {
  return s(t, !1, r);
}

function l(t, r) {
  return s(t, !0, r);
}

function f(t, r) {
  return s(t, !0, r, !0);
}

function s(t, r, n, o) {
  var a = (e().nextActionId++).toString(),
      u = function u() {
    for (var e = [], u = 0; u < arguments.length; u++) {
      e[u] = arguments[u];
    }

    var c = n ? n.apply(null, e) : {};
    if (c.type) throw new Error("Action creators should not include the type property.");
    return c.type = t, p(c, a), r && o ? function (t) {
      return Promise.resolve().then(function () {
        return i(t);
      });
    }(c) : (r && i(c), c);
  };

  return p(u, a), u;
}

function h(t) {
  return t.__SATCHELJS_ACTION_ID;
}

function p(t, r) {
  t.__SATCHELJS_ACTION_ID = r;
}

function b() {
  for (var t = [], r = 0; r < arguments.length; r++) {
    t[r] = arguments[r];
  }

  for (var n = u, o = t.length - 1; o >= 0; o--) {
    n = v(t[o], n);
  }

  e().dispatchWithMiddleware = n;
}

function v(t, r) {
  return function (n) {
    return t(r, n);
  };
}

function d() {
  return e().rootStore;
}

global.__poaSatchelGlobalContext ? function () {
  if (o !== global.__poaSatchelGlobalContext.schemaVersion) throw new Error("Detected incompatible SatchelJS versions loaded.");
}() : global.__poaSatchelGlobalContext = {
  schemaVersion: o,
  rootStore: t.map({}),
  nextActionId: 0,
  subscriptions: {},
  dispatchWithMiddleware: null,
  inMutator: !1
};

var _ = r("createStore", function (t, r) {
  d().set(t, r);
});

function w(t, r) {
  return _(t, r), function () {
    return d().get(t);
  };
}

function S(t, n) {
  var o = h(t);
  if (!o) throw new Error("Mutators can only subscribe to action creators.");
  var i = r(n);
  return a(o, function (t) {
    try {
      if (e().inMutator = !0, i(t)) throw new Error("Mutators cannot return a value and cannot be async.");
    } finally {
      e().inMutator = !1;
    }
  }), n;
}

function g(t, r) {
  var n = h(t);
  if (!n) throw new Error("Orchestrators can only subscribe to action creators.");
  return a(n, r), r;
}

function m(t) {
  return function (r, n) {
    var o = l(r, function () {
      return {
        args: arguments
      };
    });
    return t(o, function (t) {
      n.apply(null, t.args);
    }), o;
  };
}

var y = m(S),
    x = m(g);
n(!0);
export { l as action, c as actionCreator, f as asyncAction, b as applyMiddleware, w as createStore, i as dispatch, S as mutator, g as orchestrator, d as getRootStore, y as mutatorAction, x as orchestratorAction };